<script lang="ts">
  import { onMount } from "svelte"
  import { createPopper } from "@popperjs/core"
  import FlywheelEntryBox from "./FlywheelEntryBox.svelte"

  let props = $props()
  let flywheel: FlywheelType = props.flywheel
  let flywheel_entries: FlywheelEntryType[] = props.flywheel_entries

  import flywheel_arrow_bl from "@images/flywheel/flywheel-arrow-bottom-left.png"
  import flywheel_arrow_br from "@images/flywheel/flywheel-arrow-bottom-right.png"
  import flywheel_arrow_l from "@images/flywheel/flywheel-arrow-left.png"
  import flywheel_arrow_r from "@images/flywheel/flywheel-arrow-right.png"
  import flywheel_arrow_tl from "@images/flywheel/flywheel-arrow-top-left.png"
  import flywheel_arrow_tr from "@images/flywheel/flywheel-arrow-top-right.png"

  let popoverShow = $state(false)

  let popoverRef = $state(null)

  function togglePopover(target) {
    if (popoverShow) {
      popoverShow = false
    } else {
      popoverShow = true
      createPopper(target, popoverRef, {
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -20]
            }
          }
        ]
      })
    }
  }
</script>

{#if flywheel.enabled && flywheel_entries.length >= 4 && flywheel_entries.length <= 7}
  <div class="max-w-5xl mx-auto border border-blue-100 rounded shadow-lg p-6">
    <div class="grid grid-cols-3 gap-6">
      <div class="flex justify-end items-center">
        <img
          src={flywheel_arrow_tl}
          class="w-24 h-20"
          alt="Flywheel Arrow Top-Left"
        />
      </div>
      <div class="flex justify-center items-center p-8">
        <FlywheelEntryBox flywheel_entry={flywheel_entries[0]} />
      </div>

      <div class="flex justify-start items-center">
        <img
          src={flywheel_arrow_tr}
          class="w-24 h-20"
          alt="Flywheel Arrow Top-Right"
        />
      </div>
    </div>

    <div class="grid grid-cols-3 gap-6">
      <div class="flex justify-center items-center flex-col gap-y-6">
        {#if flywheel_entries.length == 6}
          <FlywheelEntryBox flywheel_entry={flywheel_entries[5]} />

          <img
            src={flywheel_arrow_l}
            class="w-auto h-16"
            alt="Flywheel Arrow Left"
          />

          <FlywheelEntryBox flywheel_entry={flywheel_entries[4]} />
        {:else if flywheel_entries.length == 5}
          <FlywheelEntryBox flywheel_entry={flywheel_entries[4]} />
        {:else if flywheel_entries.length == 4}
          <FlywheelEntryBox flywheel_entry={flywheel_entries[3]} />
        {/if}
      </div>

      <div class="flex justify-center items-center p-6">
        <button
          onclick={(e) => togglePopover(e.target)}
          type="button"
          class="border border-blue-50 shadow-lg flex justify-center items-center text-2xl text-gray-100 px-8 py-8 text-center h-40 bg-lwp-blue rounded-lg"
        >
          {flywheel.title}
        </button>
        <div
          bind:this={popoverRef}
          class="bg-indigo-300 border-0 mr-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg {popoverShow
            ? 'block'
            : 'hidden'}"
        >
          <div>
            <div
              class="bg-indigo-300 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-indigo-100 rounded-lg ProseMirror"
            >
              {#if flywheel?.description?.length > 0}
                {@html flywheel.description}
              {:else}
                <span class="italic">No description</span>
              {/if}
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center items-center flex-col gap-y-6">
        <FlywheelEntryBox flywheel_entry={flywheel_entries[1]} />

        {#if flywheel_entries.length > 4}
          <img
            src={flywheel_arrow_r}
            class="w-auto h-16"
            alt="Flywheel Arrow Right"
          />
          <FlywheelEntryBox flywheel_entry={flywheel_entries[2]} />
        {/if}
      </div>
    </div>

    <div class="grid grid-cols-3 gap-6">
      <div class="flex justify-end items-center">
        <img
          src={flywheel_arrow_bl}
          class="w-24 h-20"
          alt="Flywheel Arrow Bottom Left"
        />
      </div>
      <div class="flex justify-center items-center p-8">
        {#if flywheel_entries.length > 4}
          <FlywheelEntryBox flywheel_entry={flywheel_entries[3]} />
        {:else}
          <FlywheelEntryBox flywheel_entry={flywheel_entries[2]} />
        {/if}
      </div>

      <div class="flex justify-start items-center">
        <img
          src={flywheel_arrow_br}
          class="w-24 h-20"
          alt="Flywheel Arrow Right"
        />
      </div>
    </div>

    <div class="p-4 flex justify-center items-center mt-4">
      <p
        class="py-2 px-6 bg-orange-100 text-orange-500 rounded shadow text-sm italic"
      >
        Click on any box to view the description.
      </p>
    </div>
  </div>
{:else}
  <div class="p-4 flex justify-center items-center">
    <p class="p-2 bg-orange-100 text-orange-500 border rounded">
      Please add between 4 - 6 entries in order to view your Flywheel
    </p>
  </div>
{/if}
